import { createCollectionReducer } from '~/state/lib';

export default createCollectionReducer('agents', { initCurrentId: false });
